<template>
  <div>
  <div class="contents-ttl container-xl">

    <div class="main-ttl container-xl">
      <h2 v-if="headingTitle && !$slots['heading']">
        <span>{{ headingTitle }}</span>
        <small>{{ headingDesc }}</small>
      </h2>

      <div class="btn-area">
        <Button add @click="add">監視対象登録</Button>
      </div>
    </div>
  </div>
  <main v-if="!items" class="container-xl"></main>
  <main v-else-if="items.length === 0" class="container-xl">
    <div class="primary-area">
      <section>
          <div class="add-item frame-dashed">
            <a href="#" class="link-area" @click.prevent="add"></a>
            <p>まだ監視する対象が<span>登録されていません。</span></p>
            <button class="btn btn-main">
              <div class="ico-base ico-add"><div class="ico-plus"></div></div>監視対象登録
            </button>
            <small>監視デバイスのみを登録するには
              <a href="#" class="link-blue" @click.prevent="addMonitoringDevice">設定ページ</a>
              から行ってください。</small>
          </div>
      </section>
    </div><!-- end .primary-area -->
  </main>
  <main v-else class="container-xl">
    <div class="primary-area">
      <section>
        <div class="flex small list-head small">
          <div>表示画像</div>
          <div class="ps-4">監視対象名</div>
          <div class="col-4 ps-auto">アラート状態</div>
          <div class="col-2 ps-auto">監視デバイス状況</div>
        </div>

        <ul v-if="items" class="list-unstyled device-list">
          <MonitoringTargetsListItem
            :key="index"
            :item="item"
            v-for="(item, index) in items"
          />
        </ul>
      </section>
    </div>
  </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Button } from "components";

import { BatteryEmptyIcon, BatteryIcon, SettingIcon } from "icons";
import { SampleImage6 } from "img";
import { RepositoryFactory } from "repositories/factory";

import MonitoringTargetsListItem from "./components/ListItem.vue";

const utilState = require("utils/state");

const MonitoringTargetsRepository = RepositoryFactory.get("monitoring-targets");

export default {
  name: "MonitoringTargets",
  components: {
    Button,
    MonitoringTargetsListItem,
  },
  data() {
    return {
      icons: {
        BatteryEmptyIcon,
        BatteryIcon,
        SettingIcon,
      },
      img: {
        SampleImage6,
      },
      items: null,
      htmlNote: "",
      paymentCycle: "",
      headingTitle: "監視対象",
      headingDesc: "監視対象ごとの現在の状態を一覧表示します。",
    };
  },
  computed: {
    ...mapGetters({
      userAccount: "profile/userAccount",
      // service-account
      serviceAccountList: "service-account/serviceAccountList",
      currentServiceAccount: "service-account/currentServiceAccount",
      // asig-project
      asigProjectList: "asig-project/asigProjectList",
      currentAsigProject: "asig-project/currentAsigProject",
      /* 監視対象の削除通知 */
      deleteMonitoringTargetNotificationFlag:
        "application/deleteMonitoringTargetNotificationFlag",
    }),
  },
  async created() {
    try {
      await utilState.updateProfileState();
      await utilState.updateServiceAccountState();
      await utilState.updateAsigProjectState(this.currentServiceAccount.serviceAccountId);

      console.log(this.currentAsigProject.asigProjectId);
      const monitoringTargets = await MonitoringTargetsRepository.index(
        this.currentAsigProject.asigProjectId,
      );
      this.updateItems(monitoringTargets);

      /* 通知処理　*/
      if (this.deleteMonitoringTargetNotificationFlag === true) {
        this.setNotification({
          message: "監視対象を削除しました。",
        });
        this.updateDeleteMonitoringTargetNotificationFlag(false);
      }
    } catch (err) {
      console.log(err);
      // TODO: 発生したエラーを画面に反映
    }
  },
  methods: {
    ...mapActions({
      updateDeleteMonitoringTargetNotificationFlag:
        "application/updateDeleteMonitoringTargetNotificationFlag",
      setNotification: "notification/setNotification",
    }),
    updateItems(monitoringTargets) {
      // dictへの変換
      const items = [];
      monitoringTargets.forEach((v) => {
        items.push({
          monitoringTarget: v,
        });
      });
      this.items = items;
    },
    add() {
      this.$router.push({ name: "MonitoringTargetsCreate" });
    },
    addMonitoringDevice() {
      this.$router.push({ name: "MonitoringDeviceCreate" });
    },
  },
};
</script>
